import React from 'react';
import {Avatar, CardActionArea, CardContent, CardHeader, Chip} from "@mui/material";
import Typography from "@mui/material/Typography";
import {capitalizeFirstLetter, capitalizeWords, diffDays} from "../../../../utils/GenericUtils";
import {calcPunteggioQuarantenaBoolean} from "../../quarantene/monitoraggi/form/MonitoraggioQuarantenaGrid";
import {
	calcPunteggioIsolamento
} from "../../quarantene/monitoraggi/form/MonitoraggioIsolamentoGrid";
import moment from "moment";
import ErrorOutlineTwoToneIcon from '@mui/icons-material/ErrorOutlineTwoTone';
import RadioButtonUncheckedTwoToneIcon from '@mui/icons-material/RadioButtonUncheckedTwoTone';
import CheckCircleOutlineTwoToneIcon from '@mui/icons-material/CheckCircleOutlineTwoTone';
import {useTheme} from "@mui/styles";
import {getDataLabel} from "../../../../utils/TableUtils";
import multiavatar from "@multiavatar/multiavatar";
import SVG from "react-inlinesvg";
import {getScoreColor} from "../../quarantene/detail/QuarantenaCard";
import AccessTimeTwoToneIcon from "@mui/icons-material/AccessTimeTwoTone";
import {orange, purple} from "@mui/material/colors";
import LabelTwoToneIcon from "@mui/icons-material/LabelTwoTone";

const FocolaioCard = ({focolaio, goToFocolaio}) => {
	let theme = useTheme();
	
	return (
        <React.Fragment>
            <CardActionArea onClick={() => goToFocolaio(focolaio)}>
				<CardHeader
					style={{paddingBottom: 2}}
					title={
						<Typography variant={"subtitle1"}><b> Associazione {focolaio.id}</b>
							{
								focolaio.alias && <span style={{
									paddingLeft: 10,
									paddingRight: 10,
									marginLeft: 18,
									borderRadius: 24,
									backgroundColor: theme.palette.primary.main,
									color: "#FFF"
								}}><b>{focolaio.alias}</b></span>
							}
						</Typography>
					}
					subheader={focolaio.active ?
						<Typography variant={"body2"} color={"error"}>
							In gestione da parte di <b>{focolaio.lastModify}</b>
						</Typography> :
						<Typography variant={"body2"} color={"textSecondary"}>
							Ultima modifica: <b>{getDataLabel(focolaio.dataUltimaModifica)}</b> da parte
							di <b>{focolaio.lastModify}</b>
						</Typography>}
				/>
				<CardContent style={{paddingTop: 8}}>
					{
						focolaio.quarantene.map((quarantena) => {
							return (
                                <div key={quarantena.id}
								     style={{
									     border: theme.palette.mode === "light" ? "2px solid #f4f4f4" : "2px solid #343434",
									     borderRadius: 24,
									     marginBottom: 5,
									     padding: 8
								     }}>
                                    <div style={{display: "flex", padding: 5, alignItems: "center", width: "100%"}}>
										<Avatar
											style={{marginRight: 10}}>
											<SVG src={multiavatar(quarantena?.soggetto?.codF)}/>
										</Avatar>
										<Typography style={{minWidth: 212, flexGrow: 1}}>
											{quarantena.tipo === "Quarantena" ? "Autosorveglianza" : quarantena.tipo}<br/>
											<b>{capitalizeWords(quarantena.soggetto.nome) + " " + capitalizeWords(quarantena.soggetto.cognome)}</b>
										</Typography>
										<Typography variant={"body2"} color={"textSecondary"}>
											{moment(quarantena.dataInizio).format("DD/MM/YY") + " - " + moment(quarantena.dataFine).format("DD/MM/YY") + "  (" + diffDays(new Date(quarantena.dataInizio), new Date()) + "/" + diffDays(new Date(quarantena.dataInizio), new Date(quarantena.dataFine)) + ")"}
										</Typography>
										<Chip label={quarantena.stato} style={{marginRight: 10, marginLeft: 10, width: 110}}/>
										<Chip icon={calcScore(quarantena.monitoraggi, quarantena.tipo, quarantena.score) >= 3 ?
											<ErrorOutlineTwoToneIcon style={{color: "#FFF"}}/> :
											calcScore(quarantena.monitoraggi, quarantena.tipo, quarantena.score) === 0 ?
												<CheckCircleOutlineTwoToneIcon style={{color: "#FFF"}}/> :
												<RadioButtonUncheckedTwoToneIcon style={{color: "#FFF"}}/>}
										      label={"SCORE " + calcScore(quarantena.monitoraggi, quarantena.tipo, quarantena.score)}
										      style={{
											      marginRight: 10,
											      marginLeft: 10,
											      padding: 4,
											      fontWeight: "bold",
											      color: "#FFF",
											      backgroundColor: getScoreColor(quarantena.tipo, quarantena.monitoraggi, quarantena.score)
										      }}/>
									</div>
                                    <Typography variant={"body2"} color={"textSecondary"}>
										{quarantena?.note?.replaceAll(/#(\S*)/g, "")}
									</Typography>
                                    <div>
										{
											quarantena?.note?.match(/#(\S*)/g)?.map(sintomo => {
												return (
													<Chip
														key={sintomo}
														label={capitalizeFirstLetter(sintomo.replaceAll("_", " "))}
														avatar={<Avatar><b>#</b></Avatar>}
														color={"secondary"}
														style={{
															marginRight: 8,
															marginTop: 8,
														}}/>
												)
											})
										}
										{
											quarantena.ultimoMonitoraggio &&
											<Chip
												label={"Ultimo monitoraggio: " + getDataLabel(new Date(quarantena.ultimoMonitoraggio))}
												icon={<AccessTimeTwoToneIcon style={{color: "#FFF", fontSize: 18}}/>}
												style={{
													marginRight: 8,
													marginTop: 8,
													backgroundColor: orange[500],
													color: "#FFF"
												}}
											/>
										}
										{
											getLastMonitoraggioSintomi(quarantena.monitoraggi).map(sintomo => {
												return (
													<Chip
														key={sintomo}
														label={capitalizeFirstLetter(sintomo)}
														avatar={<Avatar><b>#</b></Avatar>}
														color={"secondary"}
														style={{
															marginRight: 8,
															marginTop: 8,
														}}/>
												)
											})
										}
										{
											quarantena.tag &&
											<Chip
												label={quarantena.tag}
												icon={<LabelTwoToneIcon style={{fontSize: 22, color: "#FFF"}}/>}
												color={"default"}
												style={{
													marginRight: 8,
													marginTop: 8,
													backgroundColor: purple[600],
													color: "#FFF"
												}}/>
										}
									</div>
                                </div>
                            );
						})
					}
				</CardContent>
			</CardActionArea>
        </React.Fragment>
    );
};

export function getLastMonitoraggioSintomi(monitoraggi) {
	let sintomi = [];
	if (monitoraggi.length > 0) {
		let base = monitoraggi.sort(function (a, b) {
			return new Date(b.dataInserimento) - new Date(a.dataInserimento);
		})?.[0]
		Object.entries(base).forEach(([key, value]) => {
			if (value === true && key !== "compilatoUtente") {
				if (key === "drl") {
					sintomi.push("Diff. resp. a risposo")
				} else if (key === "drr") {
					sintomi.push("Diff. resp. a letto")
				} else if (key === "drm") {
					sintomi.push("Diff. resp. in movimento")
				} else {
					sintomi.push(key.replace(/([A-Z])/g, " $1"))
				}
			}
		})
	}
	return sintomi;
}

export function calcScore(monitoraggi, tipo, quarantenaScore) {
	let score = 0;
	let intermediateScore = 0;
	if (quarantenaScore) {
		return parseInt(quarantenaScore);
	} else if (monitoraggi && monitoraggi.length > 0) {
		let sorted = monitoraggi.sort(function (a, b) {
			return new Date(b.dataInserimento) - new Date(a.dataInserimento);
		})
		if (tipo?.includes("Isolamento")) {
			score = calcPunteggioIsolamento(sorted[0]);
		} else {
			intermediateScore = calcPunteggioQuarantenaBoolean(sorted[0]);
			score = intermediateScore * 4 / 12;
		}
	}
	
	return Math.round(score);
}

export default React.memo(FocolaioCard)
